import type { Mark } from '../types'
import { MARKS, MARK_LABEL } from '../lib/marks'

// 選択時はマークごとの意味色で塗る（○=teal, △=amber, ✕=slate）
const SELECTED: Record<Mark, string> = {
  ok: 'bg-ok text-white border-ok shadow-[0_4px_12px_-4px_rgba(15,179,161,0.6)]',
  maybe: 'bg-maybe text-white border-maybe shadow-[0_4px_12px_-4px_rgba(224,161,58,0.55)]',
  no: 'bg-no text-white border-no',
}

/** ○△×の3ボタン（1つを選ぶ。未選択＝どれもアクティブでない）*/
export default function MarkPicker({
  value,
  onChange,
}: {
  value: Mark | undefined
  onChange: (m: Mark) => void
}) {
  return (
    <div className="flex gap-2">
      {MARKS.map((m) => {
        const active = value === m
        return (
          <button
            key={m}
            type="button"
            onClick={() => onChange(m)}
            aria-label={`回答: ${MARK_LABEL[m]}`}
            aria-pressed={active}
            className={`flex h-11 w-11 items-center justify-center rounded-full border-2 text-xl font-bold transition active:scale-90 ${
              active ? `${SELECTED[m]} scale-105` : 'border-line bg-white text-muted/40 hover:border-brand/40 hover:scale-105'
            }`}
          >
            {MARK_LABEL[m]}
          </button>
        )
      })}
    </div>
  )
}
